export default "__VITE_ASSET__Bpm8JzTo__"